import { formatMessage } from "lib/globalize-util";
import { Credentials, getLsidConfig, buildCallbackUrl } from "lib/lsid";

export const buildAndSubmitHiddenForm = (credentials: Credentials) => {
    try {
        const buildHiddenInput = (name: string, value: string): HTMLInputElement => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = name;
            input.value = value;

            return input;
        };

        const { root, lsidLogin } = getLsidConfig();
        const callbackUrl = buildCallbackUrl({
            redirect_after_login: credentials.redirect_after_login,
            rememberMe: credentials.rememberMe,
        });

        const form = document.createElement("form");
        form.method = "POST";
        form.action = new URL(lsidLogin, root).href;
        if (credentials.password) {
            form.appendChild(buildHiddenInput("password", credentials.password));
        }

        form.appendChild(buildHiddenInput("email", credentials.email));
        form.appendChild(buildHiddenInput("redirect_uri", callbackUrl.href));
        document.body.appendChild(form);
        form.submit();
    } catch (e) {
        throw new Error(formatMessage("Oops! Something went wrong. Please refresh and try again."));
    }
};
